import mapReferenceBasketVersion from '~/Api/PriceReferencing/mapReferenceBasketVersion';
import ReferenceBasketVersion from '~/Api/PriceReferencing/ReferenceBasketVersion';
import ApiClient from '~/ApiClient';

export interface Result {
	items: ReferenceBasketVersion[];
}

export default async function findReferenceBasketVersions(client: ApiClient): Promise<Result> {
	const request = await client.fetch('cz-price-referencing/max-price/reference-basket-versions');
	const response = await request.json();
	return { items: response.items.map(mapReferenceBasketVersion) };
}
